<template>
    <div class="restarea-modal">
        <h3 class="map-modal__title">{{ title }}</h3>
        <div class="map-modal__icons">
            <inline-svg
                v-for="icon in showIcons"
                :key="icon"
                :name="`restareas/${icon}`"
                width="15"
                classes="map-modal__svg"
            ></inline-svg>
        </div>
        <div class="map-modal__content" v-if="!gallery.length">
            {{ content }}
        </div>
        <a
            v-for="(image, index) in gallery"
            :href="image"
            :data-lightbox="title"
            :key="index"
        >
            <div
                class="map-modal__rest-image"
                :style="{
                    backgroundImage: `url('${image}')`,
                }"
            ></div>
        </a>
    </div>
</template>
<script>
import inlineSvg from "./../inlineSvg.js";

export default {
    components: {
        inlineSvg,
    },
    props: {
        title: {
            type: String,
        },
        gallery: {
            default: () => [],
        },
        markerData: {
            default: () => {},
        },
        availableSvg: {
            default: () => [
                "gas_station",
                "charging_station",
                "shop",
                "drinks",
                "food",
                "sleep",
                "wc",
                "shower",
                "parking",
                "protected_parking",
                "exchange",
                "atm",
                "playground",
                "park",
                "urban_equipment",
            ],
        },
    },

    data() {
        return {
            content: this.trans.get("map.no_images"),
        };
    },

    computed: {
        showIcons() {
            return this.availableSvg.filter((svg) => this.markerData[svg]);
        },
    },
};
</script>
